import styles from './InputSection.module.css';
import { AssetInputSection } from './AssetInputSection';
import { CampaignMetadataInputSection } from './CampaignMetadataInputSection';

export const InputSection = () => {
  return (
    <section className={styles.container} role="region" aria-label="Asset Inputs">
      <div className={styles.content}>
        <CampaignMetadataInputSection />
        <AssetInputSection />
      </div>
    </section>
  );
};
